<template>
  <div class="swiper_banner">
    <div class="swiper-container">
      <div class="swiper-wrapper">
        <div
          class="swiper-slide"
          v-for="(item, index) in applicationInfo"
          :key="index"
        >
          <div class="img-container">
            <img
              ref="img_before"
              class="img_before"
              :src="item.imgUrl"
              alt=""
              @load="onImageLoad(index)"
            />
          </div>
          <div class="text">
            <p style="font-size: 48px; font-weight: 700; margin-bottom: 8px">
              {{ item.title }}
            </p>
            <p class="font24">{{ item.msg }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper";
import "swiper/css/swiper.min.css";

export default {
  data() {
    return {
      imageLoaded: {},
      img_width: 0,
      img_height: 0,
    };
  },
  mounted() {
    new Swiper(".swiper-container", {
      pagination: ".swiper-pagination",
      slidesPerView: 2.4,
      centeredSlides: true,
      initialSlide: this.initialNum,
      slideToClickedSlide: true,
      // 间距
      spaceBetween: 80,
      keyboard: true,
      speed: 249, // 设置切换速度（毫秒）
    });
  },
  props: {
    applicationInfo: {
      type: Array,
      default: () => [],
    },
    initialNum: {
      type: Number,
      default: 1,
    },
  },
  methods: {
    onImageLoad(index) {
      this.imageLoaded[index] = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.swiper-container {
  width: 100%;
  padding: 80px 50px 50px;
  background-color: #000;
  overflow: hidden;
}

.swiper-wrapper {
  font-size: 14px;
  color: #fff;
}

.swiper-slide {
  transition: transform 0.5s ease 0.5s;
  transform: scale(0.84) !important;
  cursor: pointer;

  .img-container {
    width: 100%;
    height: 100%;
    position: relative;
    display: inline-block;
    transition: all 0.2s ease;

    &::after {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.64);
      z-index: 1;
      transition: opacity 0.2s ease;
    }
  }

  .img_before {
    // width: 649.5px;
    // height: 354.3px;
    width: 100%;
    height: 100%;
    display: block;
    transition: all 0.2s ease;
  }

  .text {
    opacity: 0;
    transition: opacity 0.2s ease 0.8s; // 同步延迟
    .font24 {
      font-size: 24px;
      font-weight: 500;
      line-height: 37px;
    }
  }
}

.swiper-slide-active {
  transform: scale(1.06) !important;

  .img-container::after {
    background-color: rgba(0, 0, 0, 0);
  }

  .text {
    opacity: 1;
  }
}

.swiper-slide-prev,
.swiper-slide-next {
  transition-delay: 0s;

  .text {
    opacity: 0;
    transition-delay: 0s; // 非激活状态无延迟
  }
}

.text {
  // width: 650px;
  width: 100%;

  height: 150px;
  margin: 0 auto;
  margin-top: 32px;
  text-align: left;
}
</style>
